module.exports = __webpack_public_path__ + "static/media/seemypetcam-5.e276de6e.png";